import classNames from "classnames";
import { useEffect } from "react";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

export default function GdLoading({ className, size = 100 }) {
  useEffect(() => {
    if (size) {
      // 设置css变量
      document.documentElement.style.setProperty(
        "--cube-loading-size",
        size + "px"
      );
      document.documentElement.style.setProperty(
        "--cube-box-size",
        size * 0.72 + "px"
      );
      document.documentElement.style.setProperty(
        "--transform-z",
        size * 0.25 * 0.72 + "px"
      );
    }
  }, [size]);

  return (
    <div className={classNames(styles["main-loading"], className)}>
      <div className={styles["cube-wrapper"]}>
        <div className={styles["cube-box"]}>
          <div className={styles["front-face"]}></div>
          <div className={styles["back-face"]}></div>
          <div className={styles["right-face"]}></div>
          <div className={styles["left-face"]}></div>
          <div className={styles["top-face"]}></div>
          <div className={styles["bottom-face"]}></div>
        </div>
      </div>
      <div className={styles["point-wrapper"]}>
        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>

        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>

        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>

        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>
        <div className={styles["point"]}></div>
      </div>
    </div>
  );
}

export const LoadingDialog = ModalWrap(function Dialog(props: any) {
  return (
    <HBModal
      {...props}
      footer={null}
      title="账号升级"
      className={styles.dialog}
    >
      <div className={styles.loading}>
        <GdLoading className={styles.cube} />
        <div>正在处理中...</div>
      </div>
    </HBModal>
  );
});
